import { render, staticRenderFns } from "./CreateMembershipView.vue?vue&type=template&id=36f5cf40"
import script from "./CreateMembershipView.vue?vue&type=script&lang=js"
export * from "./CreateMembershipView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports